// @Version: 1.0.0
import { Pipe, PipeTransform } from '@angular/core';
import {ILinkList} from './link-list.model';

@Pipe({
  name: 'linkList',
  standalone: false
})
export class LinkListPipe implements PipeTransform {
   transform(list: Object): ILinkList[] {
      if (list == null || typeof list != 'object' || Object.keys(list).length == 0) return [];
      return Object.keys(list).map(keyList => 
         {
         const item = list[keyList as keyof typeof list] as unknown as ILinkList;
         item.sort = +item.sort;
         return item;
         }).sort((a, b) => a.sort - b.sort)
   }
}
